import { Injectable, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
// import { StatusbarService } from './statusbar.service';
import { Location } from '@angular/common';

/**
 * Service load the app's language
 */
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  /* Langs */
  public langs = [
    { label: 'english', value: 'en' },
    { label: 'spanish', value: 'es' }
  ];
  public rtlLangs = [{ label: 'arabic', value: 'ar' }];

  public changeLanguageEvent: EventEmitter<any> = new EventEmitter();
  public isRtl: boolean;

  // Dynamic translations depending on loaded modules
  public lazyLoadedModules: string[] = [];

  constructor(
    public translate: TranslateService,
    public router: Router,
    private location: Location
  ) //  private statusbarService: StatusbarService
  {}

  /**
   * Init load the languages
   */
  initialize() {
    const langs: any[] = this.langs.map((val) => {
      return val.value;
    });

    // langs.push(...this.rtlLangs);

    this.translate.addLangs(langs);
    this.translate.setDefaultLang(this.getDefaultLanguage(langs));
    this.translate.use(
      this.translate.getDefaultLang() || localStorage.getItem('lang')
    );
    localStorage.setItem('lang', this.translate.currentLang);
    // this.rtlLangs.includes(this.translate.getDefaultLang())
    //   ? (this.isRtl = true)
    //   : (this.isRtl = false);
  }

  /**
   * Get default language, by default get the browser lang
   * or get the first in the array
   */
  getDefaultLanguage(langs: string[]): string {
    let lang: string;

    if(this.location.path().split('/')[1]){
      if(0<=langs.indexOf(this.location.path().split('/')[1])){
        return this.location.path().split('/')[1];
      }
    }

    if (!lang) {
      lang = this.translate.getBrowserLang();


      if (langs.indexOf(lang) < 0) {
        lang = langs[0];
      } else {
        // if(lang!=='en'&&!this.location.path().includes(this.translate.currentLang)) {
        //     this.router.navigateByUrl('/'+lang);
        // }
      }
    }
    return lang;
  }

  /**
   * Load a single translation module
   * @param moduleName the name of the module
   */
  loadModuleTranslations(moduleName: string) {
    if (!this.lazyLoadedModules.includes(moduleName)) {
      this.lazyLoadedModules.push(moduleName);
    }
    this.translate.currentLoader
      .getTranslation(
        moduleName + '/' + moduleName + '-' + this.translate.currentLang
      )
      .subscribe(newTranslations => {
        this.translate.setTranslation(
          this.translate.currentLang,
          newTranslations,
          true
        );
      });
  }

  /**
   * Change the language of applicatoin
   * and save it in localstorage
   * @param language language to change 'es' | 'en' | 'pt'
   */
  changeLanguage(language: string) {
    //    this.statusbarService.clear();

    if (this.translate.currentLang !== language) {

      if(this.location.path().includes(this.translate.currentLang)){
        window.history.replaceState({}, '',this.location.path().replace(this.translate.currentLang, language));
      } else {

      }

      this.translate.use(language).subscribe(
        res => {

          this.lazyLoadedModules.forEach(moduleName => {

            this.loadModuleTranslations(moduleName);
          });
          // this.rtlLangs.includes(language)
          //   ? (this.isRtl = true)
          //   : (this.isRtl = false);
          //         this.statusbarService.addWithParams('UserModule.UserPreferences.Statusbar.LanguageChanged', [language]);
          localStorage.setItem('lang', language);
          this.changeLanguageEvent.emit(true);
        },
        error => {
          //         this.statusbarService.addWithParams('UserModule.UserPreferences.Statusbar.LanguageNotChanged', [language]);
        }
      );
    } else {
      //      this.statusbarService.addWithParams('UserModule.UserPreferences.Statusbar.LanguageNotChanged', [language]);
    }
  }
}
